// extracted by mini-css-extract-plugin
module.exports = {"namePlaceholder":"ListItemUser_namePlaceholder__yfkt9"};